export const useOrganizationId = () => {
   const route = useRoute()

   return computed(() => (route.params.id as string) || '')
}
